import React, { useState } from 'react';
import { FieldLabel } from '@measured/puck';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ITextFieldOptions } from '../../../interface/formInterface';
import ColorPicker from '../../../puck/reusable-props/ColorPicker';
import CustomTooltip from '../../../../components/common/tooltip';
import InputField from '../../../../components/common/input-field';
import { Select } from '../../form-fields/Select';
import { placeholderfontWeightOptions } from '../../../puck/reusable-props/TextCustomInput';
import { fontFamilies } from '../../../puck/reusable-props/options';
import BackgroungColorComponent from '../../customComponents/BackgroungColorComponent';
import { Switch } from '@mui/material';
import PaddingComponent from '../../customComponents/PaddingComponent';

interface inputFormOptionProps {
  value: ITextFieldOptions;
  onChange: (_value: ITextFieldOptions) => void;
  name: string;
}
export const InputFormField = ({
  value,
  onChange,
  name,
}: inputFormOptionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const separateWords = (input: string) => {
    if (!input) {
      return '';
    }
    return input.replace(/([a-z])([A-Z])/g, '$1 $2');
  };
  return (
    <div>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{separateWords(name)}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-3 border border-gray-300 rounded p-2 w-full">
          <>
            <ColorPicker
              value={value?.color} // Assuming `value.color` holds the color information
              onChange={newColor => {
                onChange({ ...value, color: newColor });
              }}
              label="Color"
              tooltip="Choose a color for the checkbox"
            />

            <FieldLabel
              label={
                (
                  <CustomTooltip title="Text">
                    <span>FontSize</span>
                  </CustomTooltip>
                ) as React.ReactNode as string
              }
              el="div">
              <InputField
                value={value?.fontSize}
                onChange={e => {
                  let newValue = e.replace(/[^0-9%]/g, '');

                  // Ensure that only one '%' symbol remains at the end
                  if (newValue?.includes('%')) {
                    newValue =
                      newValue.replace(/%.*%/g, '%').replace(/%/g, '') + '%';
                  }

                  // If the string is empty or contains only whitespace, set to 'auto'
                  if (!newValue.trim()) {
                    newValue = 'auto';
                  }

                  // If the value includes both digits and '%', clean up any non-digit/% characters
                  if (/\d/.test(newValue) && /%/.test(newValue)) {
                    newValue = newValue.replace(/[^0-9%]/g, '');
                  }

                  // Default to 'auto' if the value is still empty
                  if (!newValue.trim()) {
                    newValue = 'auto';
                  }

                  onChange({ ...value, fontSize: newValue });
                }}
              />
            </FieldLabel>
            <FieldLabel
              label={
                (
                  <CustomTooltip title="fontWeight">
                    <span>Font Weight</span>
                  </CustomTooltip>
                ) as React.ReactNode as string
              }
              el="div">
              <Select
                value={value?.fontWeight}
                onChange={event =>
                  onChange({
                    ...value,
                    fontWeight: event.target.value,
                  })
                }
                options={placeholderfontWeightOptions}
              />
            </FieldLabel>

            <FieldLabel
              label={
                (
                  <CustomTooltip title="fontWeight">
                    <span>Font Family</span>
                  </CustomTooltip>
                ) as React.ReactNode as string
              }
              el="div">
              <Select
                value={value?.fontFamily}
                onChange={event =>
                  onChange({
                    ...value,
                    fontFamily: event.target.value,
                  })
                }
                options={fontFamilies}
              />
            </FieldLabel>
            <BackgroungColorComponent
              value={
                value.textBackgroundColor || {
                  color: '',
                  isInherit: false,
                }
              }
              onChange={newColor => {
                onChange({ ...value, textBackgroundColor: newColor });
              }}
              title="Background Color"
            />
            {separateWords(name) === 'Product Variant' && (
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Hide Image">
                      <span>Hide Field</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Switch
                  className="flex justify-between items-center mb-3"
                  checked={value?.hideFileds || false}
                  onChange={e => {
                    const selectedValue = e.target.checked;
                    onChange({
                      ...value,
                      hideFileds: selectedValue,
                    });
                  }}
                />
              </FieldLabel>
            )}

            <PaddingComponent
              value={value.padding}
              onChange={val => {
                onChange({
                  ...value,
                  padding: val,
                });
              }}
              title="Padding"
            />
          </>
        </div>
      )}
    </div>
  );
};
